import { render, staticRenderFns } from "./ContentStatusManagementModal.vue?vue&type=template&id=19dd1fca&scoped=true&"
import script from "./ContentStatusManagementModal.vue?vue&type=script&lang=js&"
export * from "./ContentStatusManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./ContentStatusManagementModal.vue?vue&type=style&index=0&id=19dd1fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dd1fca",
  null
  
)

export default component.exports